import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { IMG, FACILITIES } from "@/data/site";

export default function Facilities() {
  return (
    <div data-testid="facilities-page">
      <PageHero overline="Facilities" title="Beyond the room" subtitle="Pools, celebrations, wellness and seamless services — all under one roof." image={IMG.pool} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <Stagger className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {FACILITIES.map((f, i) => (
            <StaggerItem key={f.slug} className={i % 3 === 0 ? "md:col-span-7" : i % 3 === 1 ? "md:col-span-5" : "md:col-span-6"}>
              <Link to={f.to || `/facilities/${f.slug}`} className="group block relative img-zoom aspect-[16/10]" data-testid={`facility-card-${f.slug}`}>
                <img src={f.image} alt={f.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h2 className="font-serif-display text-2xl md:text-3xl font-light text-white group-hover:text-[#d4af37] transition-colors duration-300">{f.name}</h2>
                  <p className="text-sm text-white/60 mt-1 max-w-md">{f.short}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-[#d4af37] text-xs uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                    Discover <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
